const themes = {
    default: {
      backgroundColor: '#10051e',
      containerBColor: '#210b3c',
      elementsBColor: '#2a193e',
      hoverBColor: '#3d2657',
      textColor: '#ffffff',
      hoverColor: '#ff9900',
      accentColor: '#916dbb',
      transLucid: '#000000a3',
    },
    dark: {
      backgroundColor: '#000000',
      containerBColor: '#1c1c1c',
      elementsBColor: '#3a3a3a',
      hoverBColor: '#262626',
      textColor: '#ffffff',
      hoverColor: '#ff9900',
      accentColor: '#916dbb',
      aColor: '#ffffff',
      transLucid: '#000000a3',
    },
    light: {
      backgroundColor: '#ffffff',
      containerBColor: '#f2f2f2',
      elementsBColor: '#e6e6e6',
      hoverBColor: '#d9d9d9',
      textColor: '#000000',
      hoverColor: '#ff9900',
      accentColor: '#916dbb',
      aColor: '#000000',
      transLucid: '#ffffffb2',
    },
    bitcoin: {
        backgroundColor: '#f90',
        containerBColor: '#ffdca8',
        elementsBColor: '#ffc267',
        hoverBColor: '#ffce84',
        textColor: 'black',
        hoverColor: '#a56300',
        accentColor: '#6a440a',
        aColor: 'black',
        transLucid: '#ffffffb2',
      },
      ocean: {
        backgroundColor: '#0d1b33',
        containerBColor: '#1e3a6c',
        elementsBColor: '#285198',
        hoverBColor: '#2f6cac',
        textColor: '#ffffff',
        hoverColor: '#ff9900',
        accentColor: '#00a0b0',
        aColor: '#ffffff',
        transLucid: '#000000a3',
      }
      
  };
  
  export default themes;
  